<form [formGroup]="form" (ngSubmit)="onSubmit()" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
  @if (!isCheckData) {
    <div class="mt-6 mb-3">
      <h1 class="text-primary">¡Sigue avanzando!</h1>
    </div>
  }

  @if (!isCheckData && isLoadingData()) {
    <p class="text-sm text-gray-500 w-full text-center">Cargando tu información...</p>
  }

  @for (config of visibleDataInputs(); track config.formName) {
    <div class="w-full space-y-3">
      <app-input
        class="w-full block"
        [config]="config"
        [timeoutSeconds]="0.6"
        (submitValue)="handleValue($event)"
        (fieldStateChange)="onFieldStateChange()"
      ></app-input>

      @if (isCheckData && dataLastOnboarding && dataLastOnboarding[config.formName ?? ''] !== undefined) {
        <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
          <div class="flex items-center gap-2">
            <span class="text-xs text-label">Anterior:</span>
            <span class="font-medium text-base-content">
              {{ dataLastOnboarding[config.formName ?? ''] | number:'1.0-0' }}
            </span>
          </div>
          <span class="text-xs text-label">COP</span>
        </div>
      }
    </div>
  }

  @if (!isCheckData && validationMessage()) {
    <p class="text-red-500 text-xs w-full text-center px-2">{{ validationMessage() }}</p>
  }

  @if (!isCheckData) {
    <button class="btn-primary mb-6" [disabled]="!canContinue() || isSubmitting()" type="submit">
      {{ isSubmitting() ? 'Guardando...' : 'Continuar' }}
    </button>
  }
</form>
